import { LoadedUser } from '../../interfaces';
import { OrganizationBusiness } from '../../types/organizations';

export type ArtistDefaultReplySource = {
  loadedUser: Pick<LoadedUser, 'business' | 'employee'> | null | undefined;
  employeeId?: string | null;
  business?: Pick<OrganizationBusiness, 'employeesToBusinesses'> | null;
};

export type ArtistDefaultReplyDecision = {
  shouldApply: boolean;
  value: string;
  lastAppliedDefault: string;
};

export function getArtistDefaultReply({
  loadedUser,
  employeeId,
  business,
}: ArtistDefaultReplySource): string {
  if (!employeeId) return '';

  const orgMessage = business?.employeesToBusinesses?.find(
    etb => etb.employeeId === employeeId,
  )?.employee?.standardDesignMessage;
  if (orgMessage != null) return orgMessage;

  const rosterMessage = loadedUser?.business?.employees?.find(
    e => e.employeeId === employeeId,
  )?.standardDesignMessage;
  if (rosterMessage != null) return rosterMessage;

  if (loadedUser?.employee?.employeeId === employeeId) {
    return loadedUser.employee.standardDesignMessage ?? '';
  }

  return '';
}

export function getNextArtistDefaultReply({
  currentReply,
  lastAppliedDefault,
  nextDefault,
}: {
  currentReply: string | null | undefined;
  lastAppliedDefault: string;
  nextDefault: string;
}): ArtistDefaultReplyDecision {
  const current = currentReply ?? '';
  const wasPristine = current === lastAppliedDefault;
  return {
    shouldApply: wasPristine,
    value: wasPristine ? nextDefault : current,
    lastAppliedDefault: nextDefault,
  };
}
